import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  ViewContainerRef,
  ViewChild,
  ViewChildren,
  ContentChild,
  QueryList,
  ElementRef,
  AfterViewInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  HostListener
} from "@angular/core";
import {
  FormBuilder,
  FormArray,
  FormGroup,
  Validators,
  AbstractControl,
  FormControl
} from "@angular/forms";
import {
  MwFormControlComponent,
  MwImageEditorService
} from "../../../../shared/components";
import {
  Listing,
  DayNames,
  MasterCategory,
  Category,
  Payments,
  RG,
  IFListingTime,
  CategoryListing,
  ListingServices
} from "../../../../shared/models";
import { getDayName, hoursdata } from "../../../../shared/viewmodels";
import {
  CategoriesService,
  ListingsService,
  CategoryTreeService
} from "../../../../shared/services/api";
import { environment } from "../../../../environments/environment";
import { MapwordsStore } from "../../../../shared/store";
import { toJS } from "mobx";
import { ListingTime } from "../../../../shared/models/ListingTime";
import * as _ from "lodash";
import { Router, ActivatedRoute } from "@angular/router";
import { IQuickSearchObject } from "../../../../shared/models/QuickSearchObject";
import { debug, isObject } from "util";
import { Observable } from "rxjs";
import { MatAutocomplete } from "@angular/material";
import { map } from "rxjs/operators";
import { Service } from "../../../../shared/models/Service";
import { MwHoursAgentComponent } from "../../../../shared/components/mw-hours-agent/mw-hours-agent.component";

declare let $: any;

@Component({
  selector: "mw-claim-listing",
  templateUrl: "./mw-claim-listing.component.html",
  styleUrls: ["./mw-claim-listing.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class MwClaimListingComponent implements OnInit, AfterViewInit {
  @ViewChild("imageFile")
  public imageInput: ElementRef;

  @ViewChild("bodyContainer")
  public containerElement: ElementRef;

  @ViewChild("serviceInputText")
  public serviceInputText: ElementRef;

  @ViewChildren(MwFormControlComponent)
  public formControls: QueryList<MwFormControlComponent>;

  @ViewChild("phoneNumberText")
  public phoneNumberText: ElementRef;

  @ViewChild('businessHours')
  public businessHoursElementRef: MwHoursAgentComponent;

  public listing: Listing;

  public listcnt: number;
  public dnameduplicate = false;

  public fListing: FormGroup;

  public masterCategoriesCatalog: MasterCategory[];

  public CategoryCatalog: Category[] = [];

  public inputTextInput: string;

  public get masterCategories(): FormArray {
    return <FormArray>this.fListing.get("masterCategories");
  }

  public get categories(): FormArray {
    return <FormArray>this.fListing.get("categories");
  }

  public get listingServices(): FormArray {
    return <FormArray>this.fListing.get("services");
  }

  public get hours(): FormArray {
    return <FormArray>this.fListing.get("listingHours");
  }

  // public dayhold1 = 0 ;
  // public dayhold2 = 0;
  public dayhold;

  public get listingHours(): ListingTime[] {
    //console.log(this.listing.listingHours);
    const list = _.orderBy(this.listing.listingHours, ["dayName"]);
    //console.log(this.listing.listingHours);
    return list;
  }

  public editorOpened = false;

  // List for fill the selects
  public hoursData: string[] = hoursdata;

  public imageOrigin = environment.imagesOrigin;
  public phoneDefault = environment.phoneNumberDefault;
  //public states: State[] =[];
  public states: any[] = [];

  //public serviceList: Observable<Category[]> ;
  public serviceList: Observable<Service[]>;
  public servicesControl = new FormControl();
  public selectedServices: ListingServices[] = [];

  public noscroll = false;
  public wasInside = false;

  public hitEnterFlag = false;

  public showServiceErrorMessage = false;

  public lastServiceText = "";

  public lastValidatedEmail = "";
  public bShowAll = false;

  public loading = false;

  constructor(
    private _fb: FormBuilder,
    private _categoriesService: CategoriesService,
    public store: MapwordsStore,
    private _changeRef: ChangeDetectorRef,
    private _imageEditor: MwImageEditorService,
    private _listingsService: ListingsService,
    private _viewRef: ViewContainerRef,
    private _router: Router,
    private _route: ActivatedRoute,
    private _categoryTreeService: CategoryTreeService
  ) {}

  ngOnInit() {
    this.listing = toJS(this.store.searchListing.listing);
    this.getAllStates();

    this.initForm();
    this.initSelects();

    this._categoryTreeService.GetCategoryTree().subscribe(x => {
      this.categoryTree1 = x.data;
      for (let i = 0; i < this.categoryTree1.length; i++)
        this.setCategoryTreeParents(this.categoryTree1[i], null);
      console.log(this.categoryTree1);
    });

    this.servicesControl.valueChanges.subscribe(x => {
      if (this.validateService(x)) {
        this.noscroll = true;
        this._categoriesService.GetbyServiceName(x).subscribe(x => {
          this.serviceList = Observable.of(
            x.data.filter(
              q =>
                this.selectedServices.findIndex(
                  s => s.service.toLowerCase() === q.name.toLowerCase()
                ) == -1
            )
          );
        });
      }
    });
  }

  public validateService(serviceName: string): boolean {
    let response = true;

    if (
      serviceName == undefined ||
      serviceName == null ||
      serviceName == "" ||
      isObject(serviceName)
    ) {
      response = false;
    } else if (serviceName.length < 2) {
      response = false;
    }

    return response;
  }

  @HostListener("document:click")
  clickout() {
    if (!this.wasInside) {
      this.noscroll = false;
    } else {
      this.noscroll = true;
    }

    this.wasInside = false;
  }

  public setScroll() {
    console.log("setScroll");
    this.wasInside = true;
    this.noscroll = false;
  }

  ngAfterViewInit() {
    this.formControls.forEach(x => (x.formDirty = false));
  }

  private setCategoryTreeParents(tree: any, parent: any) {
    if (tree != null) {
      {
        tree.highlited = false;
        if (parent != null) tree.parent = parent;
        if (tree.subCategories != null) {
          for (let i = 0; i < tree.subCategories.length; i++)
            this.setCategoryTreeParents(tree.subCategories[i], tree);
        }
      }
    }
  }

  public checkCategory(): boolean {
    if (
      this.SelectedCategoryTreeItems.length < 1 ||
      this.SelectedCategoryTreeItems.length > 3
    ) {
      return false;
    }

    return true;
  }

  public checkService(): boolean {
    if (this.selectedServices.length < 1 || this.selectedServices.length > 10) {
      return false;
    }

    return true;
  }

  public changeHours(hours: ListingTime[]): void {
    console.log(hours);

    if (!hours.length) {
      return;
    }

    const formHours = <FormArray>this.fListing.get("listingHours");

    for (let index = 0; index < formHours.length; index++) {
      formHours.removeAt(index);
    }

    for (let index = 0; index < hours.length; index++) {

      if(hours[index].closed) {
        hours[index].start = null;
        hours[index].end = null;
      }

      // if( !(hours[index].start && hours[index].end) && !hours[index].closed){
      //   hours.splice(index,1);
      // }
    }


    this.fListing.value.listingHours = hours;

    this.listing.listingHours = hours;

    console.log(this.listing.listingHours);

    let index = 0;

    this.setFormHours().forEach(x => {
      formHours.setControl(index, x);
      index++;
    });
  }

  public claim(formListing: Listing) {
    // console.log('this.fListing.valid');
    // console.log(this.fListing);
    // console.log('this.dnameduplicate');
    // console.log(this.dnameduplicate);

    this.loading = true;

    this.fListing.value.categories = this.SelectedCategoryTreeItems;

    // console.log('this.fListing');
    // console.log(this.fListing.value);

    if (
      this.fListing.valid &&
      !this.dnameduplicate &&
      this.checkCategory() &&
      this.checkService()
    ) {
      const listing = new Listing(formListing);
      listing.businessAddress = this.listing.businessAddress;
      listing.googlePlaceId = this.listing.googlePlaceId;
      //listing.contact.contactName = this.listing.name;
      listing.name = this.fListing.value.companyName;
      listing.overallStars = this.listing.overallStars;
      listing.monthlyPrice = this.listing.monthlyPrice;
      listing.rankingOrder = this.listing.rankingOrder;
      listing.openNow = this.listing.openNow;
      listing.businessAddress.street = formListing.businessAddress.street;
      listing.businessAddress.city = formListing.businessAddress.city;
      listing.businessAddress.zipCode = formListing.businessAddress.zipCode;
      listing.businessAddress.state = formListing.businessAddress.state;
      // listing.listingHours = this.listing.listingHours;

      listing.services = this.selectedServices;

      // Extra validation for contact phone
      if (this.phoneDefault) {
        listing.contact.phoneNumber = this.listing.contact.phoneNumber;
      } else {
        listing.contact.phoneNumber = this.phoneNumberText.nativeElement.value;
        if (listing.contact.phoneNumber.startsWith("+1 ")) {
          listing.contact.phoneNumber = listing.contact.phoneNumber.substring(
            3
          );
        }
        this.fListing.value.contact.phoneNumber = listing.contact.phoneNumber;
        this.store.searchListing.listing.contact.phoneNumber =
          listing.contact.phoneNumber;
      }

      if (this.fListing.value.avatar === this.listing.avatar) {
        this.fListing.value.avatar = this.listing.avatar;
      }
      listing.categories = this.SelectedCategoryTreeItems;

      this.store.searchListing.claim(listing, () => {
        this.store.searchListing.closeClaim();
        this.store.searchListing.verifyIsOpen = true;
      });
    } else {
      this.containerElement.nativeElement.scrollTop = 0;
      this.markAllDirty(this.fListing);
      this.formControls.forEach(x => (x.formDirty = true));

      this.loading = false;
    }
  }

  public getDayName(day: number) {
    return getDayName(day);
  }

  public searchRegularCategories = (term: string) => {
    return this._categoriesService.GetbyCategoryName(term).map(x => x.data);
  };

  public getAllStates() {
    this._listingsService.GetAllStates().subscribe(res => {
      let statelist: any[] = [];
      statelist = res.data;

      let data = { name: "", value: "" };
      statelist.forEach(x => {
        data.name = x.name;
        data.value = x.code;
        //console.log(data);
        this.states.push({ name: x.code, value: x.code });
        //console.log(this.states);
      });
    });
  }

  public addToList(id: string, listName: string): void {
    let list: FormArray;
    switch (listName) {
      case "masterCategories":
        const mCat = this.masterCategoriesCatalog.find(x => x.id === +id);
        list = <FormArray>this.fListing.get(listName);
        const exist = list.controls.find(x => x.value.MasterCategoryId === +id);
        if (!exist) {
          list.push(
            this._fb.group({
              MasterCategoryId: [mCat.id],
              viewName: [mCat.description]
            })
          );
        }
        break;
      case "categories":
        const category = <FormArray>this.fListing.get("categories");
        const existCat = category.controls.find(x => x.value.viewName === id);
        if (!existCat) {
          this._categoriesService.GetbyCategoryName(id).subscribe(x => {
            const lCat = x.data.find(m => m.description === id);
            if (lCat == null || lCat == undefined) {
              return;
            }
            list = <FormArray>this.fListing.get(listName);

            list.push(
              this._fb.group({
                CategoryId: lCat.id,
                viewName: lCat.description
              })
            );
          });
        }
        break;
      default:
        list = <FormArray>this.fListing.get("services");
        // let serviceName: string = id;
        // serviceName = serviceName.trim().replace(/\s+/g, ' ').toLowerCase();
        // const object = list.controls.find(x => x.value.Service === serviceName);
        // if (object) {
        //   Validators.minLength(4)
        // } else {
        //   list.push(this._fb.group({
        //     Service: serviceName
        //   }));
        // }
        const service = <FormArray>this.fListing.get("services");
        const existServ = service.controls.find(x => x.value.service === id);
        if (!existServ) {
          this._categoriesService.GetbyCategoryName(id).subscribe(x => {
            const iServ = x.data.find(m => m.description === id);
            if (iServ == null || iServ == undefined) {
              return;
            }
            list = <FormArray>this.fListing.get(listName);
            list.push(
              this._fb.group({
                ServiceId: iServ.id,
                service: iServ.description
              })
            );
          });
        }
        break;
    }
  }

  public removeFromList(categoryId: number): void {
    // const list: FormArray = <FormArray>this.fListing.get(listName);
    // list.removeAt(index);

    var x = this.findByCategoryId(this.categoryTree1, categoryId);

    this.selectService(x);
    this.clickedCategory(x);
  }

  public findByCategoryId(list: any[], id: number): any {
    let result: any;

    list.forEach(x => {
      if (x.id == id) {
        result = x;
        return result;
      } else if (x.subCategories !== undefined) {
        let tmp = this.findByCategoryId(x.subCategories, id);
        if (tmp !== undefined) {
          result = tmp;
          return result;
        }
      }
    });

    return result;
  }

  public myListFormatter(data: Category): string {
    const html = `<span>${data.description}</span>`;
    return html;
  }

  public openEditor(): void {
    this._imageEditor
      .open(this.imageOrigin + this.listing.avatar, this._viewRef)
      .subscribe(x => {
        if (x === "" || x === undefined || x === null) {
          return;
        }
        this.imageOrigin = "";
        this.fListing.value.avatar = x;
        this.fListing.get("avatar").setValue(x);
      });
  }

  public cancelEditor(): void {
    this.editorOpened = false;
    this.fListing.value.avatar = this.listing.avatar;
  }

  public validateKey(event: KeyboardEvent): boolean {
    if (
      String.fromCharCode(event.charCode).match(/[a-z0-9]/g) == null &&
      event.charCode != 0
    ) {
      return false;
    } else {
      return true;
    }
  }

  public validateDisplayname(dName: AbstractControl): boolean {
    this.listcnt = 0;
    this.dnameduplicate = false;
    this._listingsService.GetByDisplayName(dName.value).subscribe(x => {
      // console.log(this.listcnt);
      // console.log(x.data);
      x.data.forEach(c => {
        // console.log(c);
        // console.log(this.listing);
        if (c.id && c.googlePlaceId === this.listing.googlePlaceId) {
          this.dnameduplicate = false;
        } else {
          this.dnameduplicate = true;
          this.listcnt = this.listcnt + 1;
        }
      });
    });
    // console.log(this.dnameduplicate);
    return this.dnameduplicate;
  }

  private initForm(): void {
    this.fListing = this._fb.group({
      // name: [this.listing.name, [Validators.required]],
      companyName: [this.listing.name, [Validators.required]],
      displayName: [
        this.clearDisplayName(this.listing.name),
        [Validators.minLength(6)]
      ], // , this.specialCharValidator.bind(this)
      avatar: [this.listing.avatar],
      signedAvatar: [this.listing.signedAvatar],
      businessAddress: this._fb.group({
        street: [this.listing.businessAddress.street, [Validators.required]],
        city: [this.listing.businessAddress.city, [Validators.required]],
        state: [this.listing.businessAddress.state, [Validators.required]],
        zipCode: [this.listing.businessAddress.zipCode, [Validators.required]]
      }),
      contact: this._fb.group({
        mobileNumber: [this.listing.contact.mobileNumber],
        phoneNumber: [this.listing.contact.phoneNumber, [Validators.required]],
        website: [this.listing.contact.website],
        tollFreeNumber: [this.listing.contact.tollFreeNumber],
        faxNumber: [this.listing.contact.faxNumber],
        publicEmail: [this.listing.contact.publicEmail]
      }),
      payments: this._fb.group(
        {
          amex: [false],
          visa: [false],
          masterCard: [false],
          discover: [false],
          check: [false],
          cash: [false]
        },
        { validator: this.requiredCheck }
      ),
      categories: this._fb.array([
        this.listing.categories,
        [Validators.required]
      ]),
      // masterCategories: this._fb.array(this.setMasterCategories(), Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(1)])),
      services: this._fb.array([]), //, Validators.compose([Validators.minLength(1), Validators.maxLength(20)])
      listingHours: this._fb.array(this.setDates()),
      //introduction: [this.listing.introduction, [Validators.maxLength(500)]],
      introduction: [this.listing.introduction],
      listingConfigs: this._fb.group({
        showAddress: false,
        homeBasedBusiness: false,
        businessClosed: false
      })
    });

    this.SelectedCategoryTreeItems = [];
    if (
      this.listing.categories !== undefined &&
      this.listing.categories !== null
    ) {
      this.SelectedCategoryTreeItems = this.listing.categories;
    }

    this.validateDisplayname(this.fListing.controls.displayName);
  }

  clearDisplayName(val: string): string {
    let result = "";
    let wordCount = 0;

    if (val) {
      for (let i = 0; i < val.length; i++) {
        if (val.substring(i, i + 1) == " ") {
          wordCount += 1;
        }

        if (val.substring(i, i + 1).match(/[a-zA-Z0-9]/g) != null) {
          result += val.substring(i, i + 1);
        }

        if (wordCount == 2) {
          break;
        }
      }
    }

    return result.toLowerCase();
  }

  public requiredCheck(g: FormGroup) {
    let amex = g.get("amex").value,
      visa = g.get("visa").value,
      master = g.get("masterCard").value,
      discover = g.get("discover").value,
      check = g.get("check").value,
      cash = g.get("cash").value;

    if (
      amex == true ||
      visa == true ||
      master == true ||
      discover == true ||
      check == true ||
      cash == true
    ) {
      return null;
    } else {
      return { nocheck: true };
    }
  }

  private initSelects(): void {
    this._categoriesService.GetMaster().subscribe(
      x => (this.masterCategoriesCatalog = x.data),
      err => {
        // console.log(err);
        this.store.searchListing.closeClaim();
      }
    );
  }

  private setDates(): FormGroup[] {
    const days: FormGroup[] = [];

    //console.log(this.listing.listingHours);
    if (this.listing.listingHours) {
      let cnt = -1;
      this.listing.listingHours.forEach(hour => {
        cnt = cnt + 1;
        if (cnt < hour.dayName) {
          for (; cnt < hour.dayName; cnt++) {
            days.push(
              this._fb.group(<IFListingTime>{
                active: true,
                addedDate: null,
                closed: true,
                dayName: cnt,
                end: null,
                start: null,
                id: 0,
                isSpecialHour: false
              })
            );
          }
        } else {
          cnt = hour.dayName;
        }
        days.push(
          this._fb.group(<IFListingTime>{
            active: true,
            addedDate: null,
            closed: hour.closed,
            dayName: hour.dayName,
            end: hour.end,
            start: hour.start,
            id: 0,
            isSpecialHour: false
          })
        );
      });
      cnt = cnt + 1;
      if (cnt < 7) {
        for (; cnt < 7; cnt++) {
          days.push(
            this._fb.group(<IFListingTime>{
              active: true,
              addedDate: null,
              closed: true,
              dayName: cnt,
              end: null,
              start: null,
              id: 0,
              isSpecialHour: false
            })
          );
        }
      }
    } else {
      let cnt = 0;
      for (; cnt < 7; cnt++) {
        days.push(
          this._fb.group(<IFListingTime>{
            active: true,
            addedDate: null,
            closed: true,
            dayName: cnt,
            end: null,
            start: null,
            id: 0,
            isSpecialHour: false
          })
        );
      }
    }
    return days;
  }

  private setMasterCategories(): FormGroup[] {
    const cats = [];
    if (this.listing.masterCategories) {
      this.listing.masterCategories.forEach(mCat => {
        if (mCat.masterCategory.description !== "Uncategorized") {
          cats.push(
            this._fb.group({
              MasterCategoryId: [mCat.masterCategory.id],
              viewName: [mCat.masterCategory.description]
            })
          );
        }
      });
    }
    return cats;
  }

  markAllDirty(control: AbstractControl) {
    if (control.hasOwnProperty("controls")) {
      control.markAsDirty({ onlySelf: true }); // mark group
      const ctrl = <any>control;
      for (const inner in ctrl.controls) {
        this.markAllDirty(ctrl.controls[inner] as AbstractControl);
      }
    } else {
      (<FormControl>control).markAsDirty({ onlySelf: true });
    }
  }

  public get weekDaysForm(): FormArray {
    return <FormArray>this.fListing.get("weekdays");
  }

  public toggleExtraHour(dayNumber: number, added: boolean): void {
    const hours = <FormArray>this.weekDaysForm.at(dayNumber).get("hours");
    const hour = hours.at(1);
    if (hour) {
      if (hour.get("isNew")) {
        if (added) {
          //          hours.push(this.setDates());
        } else {
          hours.removeAt(1);
        }
      } else {
        //console.log(added)
        hour.get("active").setValue(added);
      }
    } else {
      if (added) {
        //        hours.push(this.setDates());
      } else {
        hours.removeAt(1);
      }
    }
  }

  public saveHours(hours: ListingTime[]): void {
    //console.log("passed data :" + hours)
    const formHours = <FormArray>this.fListing.get("listingHours");
    // tslint:disable-next-line:no-shadowed-variable
    //console.log(formHours);
    for (let index = 0; index < formHours.length; index++) {
      formHours.removeAt(index);
    }

    for (let index = 0; index < hours.length; index++) {

      if(hours[index].closed) {
        hours[index].start = null;
        hours[index].end = null;
      }

      // if( !(hours[index].start && hours[index].end) && !hours[index].closed){
      //   hours.splice(index,1);
      // }
    }

    
    this.listing.listingHours = hours;
    //console.log(this.listing.listingHours);

    let index = 0;
    this.setFormHours().forEach(x => {
      formHours.setControl(index, x);
      index++;
    });

    // this.submitForm();

    // // tslint:disable-next-line:no-shadowed-variable
    // for (let index = 0; index < formHours.length; index++) {
    //   formHours.removeAt(index);
    // }
    // this.listing.listingHours = hours;
    // index = 0;
    // this.setFormHours().forEach(x => {
    //   formHours.setControl(index, x);
    //   index++;
    // });
  }

  private setFormHours(): FormGroup[] {
    const list = [];

    if (this.listing.listingHours.length > 0) {
      this.listing.listingHours.forEach(x => {
        list.push(this.pushHours(x));
      });
    }
    return list;
  }

  private pushHours(x: any, isNew = false): FormGroup {
    return this._fb.group(<IFListingTime>{
      active: x.active,
      addedDate: x.addedDate,
      closed: x.closed,
      dayName: isNew ? +x.id : +x.dayName,
      end: x.end,
      id: isNew ? 0 : +x.id,
      isSpecialHour: x.isSpecialHour,
      listingId: this.listing.id,
      specialDate: x.specialDate,
      specialDateName: x.specialDateName,
      start: x.start
    });
  }

  public specialCharValidator(c: FormControl): { [key: string]: any } {
    if (c.value) {
      if (!c.value.match(/[-!$%^&*()_+|~=`{}\[\]:";#@'<>?,.\/]/)) {
        return null;
      } else {
        return { invalidChar: true };
      }
    }
  }

  // Category Tree

  public categoryTree1: IQuickSearchObject[];
  public categoryTree2: IQuickSearchObject[];
  public categoryTree3: IQuickSearchObject[];
  public categoryTree4: IQuickSearchObject[];

  // public selectedCategories: any[] = [];

  public SelectedCategoryTreeItems: CategoryListing[] = [];

  public selectService(item: any) {
    // console.log(item.id);
    // console.log(item.name);
    let found = false;
    let cat = new CategoryListing({
      category: item.name,
      listingId: this.listing.id,
      categoryId: item.id
    });
    //let cat = new CategoryListing({ category: item.name, listingId: this.listing.id, categoryId: item.id });
    for (let i = 0; i < this.SelectedCategoryTreeItems.length; i++) {
      // for (let i=0; i < this.selectedCategories.length ; i++) {
      if (this.SelectedCategoryTreeItems[i].categoryId == item.id) {
        //if (this.selectedCategories[i].categoryId == item.id) {
        // item.highlited = false;
        this.SelectedCategoryTreeItems.splice(i, 1);
        // this.selectedCategories.splice(i,1);
        found = true;
      }
    }

    if (!found) {
      item.highlited = true;
      this.SetSelectedTreeUp(item);
      this.SelectedCategoryTreeItems.push(cat);
      //this.selectedCategories.push(cat);
    } else if (found === true) {
      item.highlited = false;
      this.deSelectService(item);
      // this.SelectedCategoryTreeItems.pop();
      // this.selectedCategories.pop();
    }

    // console.log(this.SelectedCategoryTreeItems);

    // console.log(this.selectedCategories);
    // console.log(cat);
  }

  public SetSelectedTreeUp(item) {
    item.highlited = true;
    if (item.parent != null) {
      this.SetSelectedTreeUp(item.parent);
    }
  }

  public deSelectService(item) {
    item.highlited = false;
    if (item.parent != null) {
      this.deSelectService(item.parent);
    }
  }

  public selectedItem;

  public clickedCategory(item: any) {
    if (!item.clicked) {
      this.SetClick(item);
      item.clicked = true;
    } else if (item.clicked === true) {
      this.deClick(item);
      item.clicked = false;
    }

    if (!item.parent) {
      for (let i = 0; i < this.categoryTree1.length; i++) {
        if (item != this.categoryTree1[i]) {
          this.deClick(this.categoryTree1[i]);
        }
      }
    } else {
      for (let i = 0; i < item.parent.subCategories.length; i++) {
        if (item != item.parent.subCategories[i]) {
          item.parent.subCategories[i].clicked = false;
        }
      }
    }
    // console.log(item.clicked);
  }

  public SetClick(item) {
    item.clicked = true;
    if (item.parent != null) {
      this.SetClick(item.parent);
    }
  }

  public deClick(item) {
    item.clicked = false;
    if (item.parent != null) {
      this.deClick(item.parent);
    }
  }

  public clearCategory(i) {
    switch (i) {
      case 1:
        if (this.categoryTree2 != []) {
          this.categoryTree2 = [];
          this.categoryTree3 = [];
          this.categoryTree4 = [];
        }
      case 2:
        if (this.categoryTree3 != []) {
          this.categoryTree3 = [];
          this.categoryTree4 = [];
        }
      case 3:
        if (this.categoryTree4 != []) {
          this.categoryTree4 = [];
        }
    }
  }

  public openSubCat(i, item) {
    this.clearCategory(i);
    switch (i) {
      case 1: {
        this.categoryTree2 = item.subCategories;
        break;
      }
      case 2: {
        this.categoryTree3 = item.subCategories;
        break;
      }
      case 3: {
        this.categoryTree4 = item.subCategories;
        break;
      }
    }
    for (let j = 0; j < item.subCategories.length; j++) {
      this.deClick(item.subCategories[j]);
    }
    this.clickedCategory(item);
  }

  public displayFn(category?: Category): string | undefined {
    if (category) {
      return category.description;
    }

    return undefined;
  }

  public enableScroll() {
    this.noscroll = false;
    this.wasInside = false;
  }

  public setServiceVariable(): void {
    this.hitEnterFlag = false;
    this.lastServiceText = "";
  }

  public addService(obj: MatAutocomplete, senderInput: number) {
    //console.log(this.serviceInputText.nativeElement.value + senderInput);

    this.showServiceErrorMessage = false;

    let inputBoxText = this.serviceInputText.nativeElement.value;
    let isTextAdded =
      this.selectedServices.filter(x => x.service == this.lastServiceText)
        .length > 0;

    if (this.hitEnterFlag && senderInput == 1 && isTextAdded) {
      if (this.selectedServices.length > 0) {
        this.selectedServices.splice(this.selectedServices.length - 1, 1);
      }
    }

    this.hitEnterFlag = false;

    var selectedItem = obj.options.filter(x => x.selected == true);

    let inputLength: number = +this.serviceInputText.nativeElement.value.length;

    if (inputLength == 0) {
      return;
    }

    if (selectedItem.length == 0 && inputLength > 4) {
      if (
        this.selectedServices.filter(x => x.service == inputBoxText).length == 0
      ) {
        let item = new ListingServices({
          id: 0,
          active: true,
          service: inputBoxText,
          listingId: 0
        });

        if (!this.checkServiceIsExists(inputBoxText)) {
          this.selectedServices.push(item);
        }

        this.servicesControl.setValue("");
        this.serviceList = Observable.of([]);
      }
    } else if (
      inputLength < 5 &&
      this.selectedServices.filter(x => x.service == inputBoxText).length == 0
    ) {
      this.showServiceErrorMessage = true;
    }

    if (selectedItem !== null && selectedItem.length != 0) {
      let description = selectedItem[0].value.description;

      if (
        this.selectedServices.filter(x => x.service == description).length == 0
      ) {
        let item = new ListingServices({
          id: 0,
          active: true,
          service: description,
          listingId: 0
        });

        if (!this.checkServiceIsExists(description)) {
          this.selectedServices.push(item);
        }

        this.servicesControl.setValue("");
        this.serviceList = Observable.of([]);
      }
    }
    this.servicesControl.setValue("");
    this.serviceList = Observable.of([]);

    this.enableScroll();
  }

  public checkServiceIsExists(serviceName: string): boolean {
    let result = false;

    if (this.selectedServices.length > 0) {
      this.selectedServices.forEach(element => {
        if (
          element.service.toLowerCase().trim() ==
          serviceName.toLowerCase().trim()
        ) {
          result = true;
        }
      });
    }

    return result;
  }

  public removeService(index: number) {
    this.selectedServices.splice(index, 1);
  }

  public hitEnter(e) {
    //console.log(this.serviceInputText.nativeElement.value.length > 4);
    //console.log(this.selectedServices.filter(x => x.service == this.serviceInputText.nativeElement.value).length == 0);

    e.preventDefault();

    this.showServiceErrorMessage = false;

    this.hitEnterFlag = false;
    this.lastServiceText = "";
    let inputBoxText = this.serviceInputText.nativeElement.value;

    if (this.serviceInputText.nativeElement.value.length > 4) {
      if (
        this.selectedServices.filter(x => x.service == inputBoxText).length == 0
      ) {
        let item = new ListingServices({
          id: 0,
          active: true,
          service: inputBoxText,
          listingId: 0
        });

        if (!this.checkServiceIsExists(inputBoxText)) {
          this.selectedServices.push(item);
          this.hitEnterFlag = true;
          this.lastServiceText = item.service;
          this.enableScroll();
        }

        this.servicesControl.setValue("");
        this.serviceList = Observable.of([]);
      }
    } else if (
      this.serviceInputText.nativeElement.value.length < 5 &&
      this.selectedServices.filter(x => x.service == inputBoxText).length == 0
    ) {
      this.showServiceErrorMessage = true;
    }
  }
}
